/**
 * This file contains all theme related constants.
 */
export const DARK_THEME_CLASS = 'theme--dark';

/**
 * Class name used to apply the light theme to the application.
 */
export const LIGHT_THEME_CLASS = 'theme--light';